import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './en'
import es from './es'
import { required, email, min, confirmed, is } from 'vee-validate/dist/rules'
import { extend } from 'vee-validate'

Vue.use(VueI18n)
const messages = {
  en: en,
  es: es,
}

const defaultLangague = (navigator.language || navigator.userLanguage).split('-')[0] === 'es' ? 'es' : 'en'

export const i18n = new VueI18n({
  locale: defaultLangague,
  fallbackLocale: defaultLangague,
  messages,
})

extend('required', {
  ...required,
  message: (_, values) => i18n.t('validations.messages.required', values),
})

extend('is', {
  ...is,
  message: (_, values) => i18n.t('validations.messages.required', values),
})

extend('min', {
  ...min,
  message: (_, values) => i18n.t('validations.messages.min', values),
})

extend('email', {
  ...email,
  message: (_, values) => i18n.t('validations.messages.email', values),
})

extend('confirmed', {
  ...confirmed,
  message: (_, values) => i18n.t('validations.messages.confirmed', values),
})
